export default "__VITE_ASSET__tMlCvry6__"